<template>
  <div class="app-message-box" ref="message">
    <div v-if="isExpired" class="black"></div>
    <div class="content">
      <div class="item" v-if="isExpired">
        <img class="warn" src="http://member.intelliquor.com/zy/warn_icon.png" alt="">
        <span>您当前系统订阅已过期，为不影响正常使用，请联系商务及时充值。</span>
      </div>

      <div class="item" v-else>
        <img class="warn" src="http://member.intelliquor.com/zy/warn_icon.png" alt="">
        <span>您<template  v-for="(item,idx) in msgList" ><span class="name" :key="idx">{{item.name}}</span>系统订阅有效期还剩余<strong :key="idx+'a'">{{item.days}}</strong>天，</template>为不影响正常使用，请联系商务及时充值。</span>
        <img @click="$emit('close',false)" class="close" src="http://member.intelliquor.com/zy/close_icon.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'appMessageBox',
  props:{
    msgList:{
      type:Array,
      default:()=>[]
    },
    isExpired: {
      type: Boolean,
      default: false
    }

  },
  data(){
    return {}
  }
}
</script>
<style scoped>
.app-message-box{
  /* position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%); */
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  /* background-color: #000; */
  z-index: 9999;
}
.content{
  margin: 94px auto 0;
  width: 598px;
  height: auto;
  background: #FFF1F0;
  border: 1px solid #FFA39E;
  border-radius: 2px;
  list-style: none;
  padding: 0 16px;
  position: relative;
  z-index: 1000;
}
.item{
  height: auto;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.item .warn{
  width: 16px;
  height: 16px;
}
.item .close{
  width: 12px;
  height: 12px;
  margin-top: 2px;
  cursor: pointer;
}
.item span{
  flex: 1;
  font-size: 14px;
  line-height: 22px;
  color: #333;
  cursor: context-menu;
  margin: 0 8px;
}
.item strong{
  font-size: 18px;
  line-height: 22px;
  color: #FF4D4F;
  font-weight: 400;
  padding: 0 3px;
}
.item .name {
  margin: 0;
}
.black {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .4);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}

</style>